import { Suspense } from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@components/common/sheet"
import { ChevronLeft, ChevronRight } from "lucide-react"
import Loader from "@components/common/loader"
import { Button } from "@components/common/button"
import { useNavigate, useSearchParams } from "react-router-dom"
import { NotificationTabs } from "./notification-tabs"
import { cn } from "@pma/utils/helpers"
import { useDrawer } from "@stores/drawer-store"
import useTranslator from "@hooks/use-translator"

const NotificationDrawer = () => {
  const drawer = useDrawer()

  const { translate, locale } = useTranslator()

  const navigate = useNavigate()
  const [searchParam] = useSearchParams()

  const newParams = new URLSearchParams(searchParam)

  const toggleNotifications = () => {
    if (drawer.isOpen && drawer?.context === "notifications") {
      drawer.onClose()
      return navigate(`?${newParams.toString()}`)
    } else {
      drawer.onOpen()
      drawer.setContext("notifications")
      return
    }
  }

  const backButton = () => {
    drawer.onClose()
    navigate(`?${newParams.toString()}`)
  }

  const isHebrew = locale === "he"
  const sheetSide = isHebrew ? "left" : "right"
  const isOpen = drawer.context === "notifications" && drawer.isOpen

  return (
    <Suspense fallback={<Loader />}>
      <Sheet open={isOpen} onOpenChange={toggleNotifications}>
        <SheetContent className='w-full px-4 md:min-w-[60vw] lg:min-w-[40vw]' side={sheetSide}>
          <SheetHeader className='pb-3'>
            <SheetTitle className={isHebrew ? "text-right" : "text-left"}>{translate("Notifications")}</SheetTitle>
            <div className={cn("mb-6 flex justify-between", isHebrew && "flex-row-reverse")}>
              <Button variant={"outline"} size={"icon"} onClick={backButton}>
                {isHebrew ? <ChevronRight /> : <ChevronLeft />}{" "}
              </Button>
            </div>
          </SheetHeader>
          <NotificationTabs />
        </SheetContent>
      </Sheet>
    </Suspense>
  )
}

export default NotificationDrawer
